import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Heart, Smartphone } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import ProductCard from "@/components/ProductCard";

export default function Wishlist() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/wishlist").then((r) => setItems(r.data)), []);
  useEffect(() => { if (user === false) nav("/login?next=/wishlist"); }, [user, nav]);
  useEffect(() => { if (user) load(); }, [user, load]);
  const toggle = async (p) => { await api.post("/wishlist/toggle", { product_id: p.id }); load(); };

  return (
    <div className="max-w-7xl mx-auto px-4 lg:px-8 py-6">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-5">
        <h1 className="text-2xl font-bold flex items-center gap-2"><Heart className="text-red-500 fill-red-500" /> My Wishlist</h1>
        {user && <span data-testid="wishlist-sync-badge" className="inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 px-3 py-1.5 rounded-full"><Smartphone size={13} /> Synced with your app</span>}
      </div>
      {items.length === 0 ? (
        <div className="text-center py-20 text-slate-400" data-testid="empty-wishlist">No items saved yet.</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 sm:gap-4">
          {items.map((p) => <ProductCard key={p.id} product={p} onWishlist={toggle} wished />)}
        </div>
      )}
    </div>
  );
}
